import { useWillUnmount } from '@libs/ui/ds'
import { Loader } from '@libs/ui/ds/lib/components'
import React, { Suspense } from 'react'

import { useDispatchModal } from '../hooks/useDispatchModal'
import { useReadModal } from '../hooks/useReadModal'

type HocParams = {
  name: string
}

function withModalShow({ name }: HocParams) {
  return ContentComponent => props => {
    const { close } = useDispatchModal({ name })
    const { isOpen } = useReadModal({ name })

    /**
     * When modal component is unmounted but the modal is still open in context data
     * we should force close
     */
    useWillUnmount(() => {
      close()
    }, [])

    if (!isOpen) {
      return null
    }

    return (
      <Suspense fallback={<Loader.Overlay />}>
        <ContentComponent {...props} />
      </Suspense>
    )
  }
}

export default withModalShow
